// src/pages/products/{shopifyProduct.handle}/{shopifyProductVariant.sku}.tsx

import { graphql, PageProps } from 'gatsby';
import React from 'react';

import { ProductPage } from '../../../components/products/page';
import { ProductHead } from '../../../components/products/seo';

type VariantPageProps = PageProps<Queries.VariantPageQuery>;

export default function VariantPage({ data, location }: VariantPageProps) {
  const variant = data.shopifyProductVariant!;
  const product = variant.product!;
  const storefrontProduct = data.shopifyStorefront.products.nodes[0];
  const defaultVariant = variant;

  return (
    <ProductPage
      allowUrlVariantDetection={false}
      storeReviewCount={data.storeReviewCount}
      reviewList={data.reviewList}
      shopifyAdmin={data.shopifyAdmin}
      storeReviewRating={data.storeReviewRating}
      product={product}
      defaultVariant={defaultVariant}
      storefrontProduct={storefrontProduct}
      location={location}
    />
  );
}

export const Head = ({ data, location }: PageProps<Queries.VariantPageQuery, any, any>) => {
  const product = data.shopifyProductVariant.product;
  const defaultVariant = data.shopifyProductVariant;
  const storefrontProduct = data.shopifyStorefront.products.nodes[0];

  return (
    <ProductHead
      storeReviewCount={data.storeReviewCount}
      reviewList={data.reviewList}
      shopifyAdmin={data.shopifyAdmin}
      storeReviewRating={data.storeReviewRating}
      product={product}
      defaultVariant={defaultVariant}
      storefrontProduct={storefrontProduct}
      location={location}
    />
  )
}

export const query = graphql`
  query VariantPage(
   $product__handle: String!, $sku: String!
  ) {
    shopifyProductVariant(sku: { eq: $sku }) {
      id
      title
      shopifyId
      availableForSale
      storefrontId
      price
      sku
      barcode
      presentmentPrices{
        compareAtPrice {
          amount
          currencyCode
        }
        price {
          amount
          currencyCode
        }
      }
      selectedOptions {
        name
        value
      }
      inventoryQuantity
      
      product {
        ...ShopifyProductCard
      }
    }
    shopifyAdmin {
      products(first:1, query: $product__handle){
        nodes {
          metafields(first:1, namespace: "global") {
            nodes {
              ownerType,
              key,
              namespace,
              value          
            }
          }
        }
      }
    }  
    shopifyStorefront {
      products(first: 1, query: $product__handle) {
        nodes {
         id
          metafields(identifiers: [{key: "tabs", namespace: "custom"}, {key: "highlights", namespace: "custom"}, {key: "group_sku", namespace: "custom"}]) {
            id
            key
            value
            references(first: 250) {
                nodes {
                  ...on ShopifyStorefront_Metaobject {
                    fields {
                      key
                      value
                    }
                  }
                }
            }
          }
        }
      }
    }
     storeReviewCount: judgeMeStoreReviewsCount {
      all_reviews_count
    }
    storeReviewRating: judgeMeStoreReviewsRating {
      all_reviews_rating
    }
    reviewList: allCustomJudgeMeReviewsList {
      nodes {
        rating
        body
        featured
        title
        reviewer {
          name
        }
      }
    }
  }
`;
